import React from 'react';

import UserModuleContainer from '../user-module-container/user-module-container';

import useVhValue from '../../hooks/useVhValue';

import './main-page.scss';

const MainPage = () => {
  useVhValue();

  return (
    <>
      <picture>
        <source srcSet="/main-bg/bg-desktop.jpg" media="(min-width: 1280px)" />
        <source srcSet="/main-bg/bg-tablet.jpg" media="(min-width: 768px)" />
        <img className="main-page__main-bg" alt="Cemetery landscape" />
      </picture>
      <div className="main-page__content">
        <img
          className="main-page__logo"
          src="/logos/logo-big.svg"
          alt="Cemetery logo"
          width={260}
        />
        <div className="main-page__user-module">
          <UserModuleContainer
            handleForgotPasswordButtonClick={() => {
              if (window.zE) {
                window.zE('webWidget', 'show');
                window.zE('webWidget', 'open');
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default MainPage;
